interface Props {
  readonly size?: number;
}

export default function CloseIcon(props: Props) {
  const { size = 16 } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 4L12.0002 12.0001M12.0003 4L4.00015 12.0001"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
